import { render } from "./404.vue?vue&type=template&id=3dc6c58e"
const script = {}

import exportComponent from "/codebuild/output/src703991735/src/Jessy-Rent-O-/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__